export default "__VITE_ASSET__DJUxf23L__"